<router-outlet></router-outlet>

<!-- Sidebar modals are below -->

<app-lottery-details *ngIf="tixxSelectOverviewService.listOfModals.editLotteryDetailsModalOpened"
                     [lottery]="selectedLottery">
</app-lottery-details>

<app-process-configuration *ngIf="tixxSelectOverviewService.listOfModals.editProcessConfigurationModalOpened"
                           [selectedLottery]="selectedLottery">
</app-process-configuration>

<app-webpage-individualization *ngIf="tixxSelectOverviewService.listOfModals.editWebpageIndividualizationModalOpened"
                               [selectedLottery]="selectedLottery">
</app-webpage-individualization>

<app-optional-checkbox *ngIf="tixxSelectOverviewService.listOfModals.editSpecialRequirementModalOpened"
                      [selectedLottery]="selectedLottery">
</app-optional-checkbox>

<app-price-category-create *ngIf="tixxSelectOverviewService.listOfModals.createPriceCategoriesModalOpened"
                           [selectedLottery]="selectedLottery">
</app-price-category-create>

<app-price-category-edit *ngIf="tixxSelectOverviewService.listOfModals.editPriceCategoriesModalOpened"
                         [selectedLottery]="selectedLottery">
</app-price-category-edit>

<app-price-reduction-create *ngIf="tixxSelectOverviewService.listOfModals.createPriceReductionsModalOpened"
                            [selectedLottery]="selectedLottery">
</app-price-reduction-create>

<app-price-reduction-edit *ngIf="tixxSelectOverviewService.listOfModals.editPriceReductionsModalOpened"
                          [selectedLottery]="selectedLottery">
</app-price-reduction-edit>

<app-assigned-reductions *ngIf="tixxSelectOverviewService.listOfModals.editAssignedReductionsModalOpened"
                         [selectedLottery]="selectedLottery">
</app-assigned-reductions>

<app-ticket-quota *ngIf="tixxSelectOverviewService.listOfModals.editTicketQuotaModalOpened">
</app-ticket-quota>
